import none from "./none";

export default function(series) {
  return none(series).reverse();
}



//////////////////
// WEBPACK FOOTER
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/~/d3-shape/src/order/reverse.js
// module id = ../../../../d3-shape/src/order/reverse.js
// module chunks = 4